// extracted by css-extract-rspack-plugin
export default {"root":"root-dQbs5s","text":"text-EgIZlJ text-base"};